import CheckboxGroup from '../checkbox/src/checkbox-group.vue';

/* istanbul ignore next */
CheckboxGroup.install = function(Vue) {
  Vue.component(CheckboxGroup.name, CheckboxGroup);
};

export default CheckboxGroup;
